<!--
    描述：保证金退款页面
    Created by asq
-->
<template>
	<div class="operation-layout">
		<div class="search"
			 v-if="!routeQuery && searchToggle">
			<el-form :model="searchForm"
					 label-width="130px">
				<el-row>
					<el-col :span="6">
						<el-form-item label="业务流水号：">
							<el-input :placeholder="'请输入'"
									  clearable
									  v-model="searchForm.seqNo"
									  size="small">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="项目标段号：">
							<el-input :placeholder="'请输入'"
									  clearable
									  v-model="searchForm.packageId"
									  size="small">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="虚拟子账户：">
							<el-input :placeholder="'请输入'"
									  clearable
									  v-model="searchForm.iacctNo"
									  size="small">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6">
						<el-form-item label="业务行：">
							<el-select v-model="searchForm.bankId"
									   placeholder="请选择"
									   size="small">
								<el-option v-for="item in bankList"
										   :key="item.id"
										   :label="item.sname"
										   :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="业务来源：">
							<el-select v-model="searchForm.source"
									   placeholder="请选择"
									   size="small">
								<el-option v-for="item in ywly"
										   :key="item.id"
										   :label="item.sname"
										   :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="交易日期：">
							<el-date-picker v-model="searchForm.evaTime"
											type="daterange"
											unlink-panels
											size="small"
											start-placeholder="请选择"
											end-placeholder="请选择">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6"
							class="mt4 ">
						<el-button type="primary"
								   class="btn-blue"
								   size="small"
								   @click="searchResult">搜索</el-button>
						<el-button type="warning"
								   size="small"
								   @click="resetSerach">重置</el-button>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="operation-main"
			 v-if="!routeQuery">
			<div class="operation-header">
				<div class="title">
					合计开票： <span class="blue">{{ total }}</span> 条
				</div>
				<div class="mt10 mb10 fr">
					<el-button type="primary"
							   class="btn-blue"
							   size="small"
							   @click="changeState">
						筛选
						<i v-if="searchToggle"
						   class="el-icon-caret-bottom ml5"></i>
						<i v-else
						   class="el-icon-caret-top ml5"></i>
					</el-button>
					<el-button size="small"
							   class="btn-blue"
							   icon="el-icon-refresh"
							   type="primary"
							   @click="refresh"></el-button>
				</div>

			</div>
			<div class="operation-container w-table-layout w-table-page">
				<div class="w-table-content"
					 v-show="tableShow">
					<el-table ref="xTable"
							  :data="filterData"
							  height="100%"
							  highlight-current-row
							  border>
						<el-table-column type="index"
										 label="序号"
										 align="center"
										 width="80"></el-table-column>
						<el-table-column prop="seqNo"
										 label="业务号"
										 align="center"
										 width="120"
										 show-overflow-tooltip></el-table-column>
						<el-table-column prop="bankName"
										 label="业务行"
										 align="center"
										 width="140"
										 show-overflow-tooltip></el-table-column>
						<el-table-column prop="packageId"
										 label="项目标段号"
										 align="center"
										 width="120"
										 show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="virtualAccount"
										 label="虚拟账户"
										 align="center"
										 min-width="140"
										 show-overflow-tooltip></el-table-column>
						<el-table-column prop="totalNum"
										 label="总笔数"
										 align="center"
										 width="140"
										 show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="transCode"
										 label="交易代码"
										 align="center"
										 min-width="120"
										 show-overflow-tooltip></el-table-column>
						<el-table-column prop="transDate"
										 label="交易日期"
										 align="center"
										 width="160"
										 show-overflow-tooltip></el-table-column>
						<el-table-column prop="transTime"
										 label="交易时间"
										 align="center"
										 width="140"
										 show-overflow-tooltip></el-table-column>
						<el-table-column prop="sourceName"
										 label="业务来源"
										 align="center"
										 width="100"
										 show-overflow-tooltip></el-table-column>
						<el-table-column prop="isFlag"
										 label="是否退款成功"
										 align="center"
										 width="140"
										 show-overflow-tooltip>
							<template slot-scope="scope">
								<span v-if="scope.row.isFlag == 0">失败</span>
								<span v-else-if="scope.row.isFlag == 1">成功</span>
							</template></el-table-column>
						<el-table-column align="center"
										 width="100">
							<template slot="header">操作</template>
							<template slot-scope="scope">
								<el-button type="primary"
										   size="small"
										   round
										   plain
										   class="table-btn"
										   @click="getDetail(scope.row)">
									<svg-icon icon-class="form-details"></svg-icon> 详情
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="w-table-footer">
					<el-pagination @size-change="handleSizeChange"
								   @current-change="handleCurrentChange"
								   :current-page="currentPage"
								   :page-sizes="pageList"
								   :page-size="pageSize"
								   :total="total"
								   layout="total, sizes, prev, pager, next, jumper">
					</el-pagination>
				</div>
			</div>
		</div>
		<div class="cmain"
			 v-if="routeQuery">
			<div class="common-top">
				<div class="text-right pdt10 hidden">
					<el-button type="primary"
							   class="btn-blue"
							   @click="goBack"
							   size="small">返回</el-button>
				</div>
				<div class="card-area">
					<el-row>
						<el-col :span="2">业务流水号：</el-col>
						<el-col class="text-overflow "
								:span="4">{{
                            detailData.seqNo ? detailData.seqNo : '-'
                        }}</el-col>
						<el-col :span="2">交易代码：</el-col>
						<el-col class="text-overflow"
								:span="4">{{
                            detailData.transCode ? detailData.transCode : '-'
                        }}</el-col>
						<el-col :span="2">交易日期：</el-col>
						<el-col class="text-overflow"
								:span="4">{{
                          detailData.transDate ? detailData.transDate : '-'
                        }}</el-col>
						<el-col :span="2">交易时间：</el-col>
						<el-col class="text-overflow"
								:span="4">{{
                            detailData.transTime ? detailData.transTime : '-'
                        }}</el-col>
						<el-col :span="2">虚拟子账户：</el-col>
						<el-col class="text-overflow"
								:span="4">{{
                            detailData.virtualAccount
                                ? detailData.virtualAccount
                                : '-'
                        }}</el-col>
						<el-col :span="2">退款总笔数：</el-col>
						<el-col class="text-overflow"
								:span="4">{{
                            detailData.totalNum ? detailData.totalNum : '-'
                        }}</el-col>
						<el-col :span="2">业务行ID：</el-col>
						<el-col class="text-overflow"
								:span="4">{{
                            detailData.bankId
                                ? detailData.bankId
                                : '-'
                        }}</el-col>
						<el-col :span="2">业务行：</el-col>
						<el-col class="text-overflow"
								:span="4">{{
                            detailData.bankName ? detailData.bankName : '-'
                        }}</el-col>
					</el-row>
				</div>
			</div>
			<el-row style="margin-top:60px;margin-left:30px">
				<span>退款明细</span> <span style="color:blue;font-size:13px;margin-left:30px">提示：保证金退款，资金将按原缴纳账户退回</span>
				<el-divider content-position="left"></el-divider>
			</el-row>
			<div class="table">
				<vxe-table ref="xTable"
						   :data="detailTable"
						   height="100%"
						   size="small"
						   highlight-current-row
						   border>
					<vxe-table-column type="seq"
									  title="序号"
									  align="center"
									  width="80"></vxe-table-column>
					<vxe-table-column field="hstSeqNum"
									  title="转账流水号"
									  align="center"
									  show-overflow-tooltip
									  width="180"></vxe-table-column>
					<vxe-table-column field="bankNo"
									  title="开户行行号"
									  align="center"
									  width="200"></vxe-table-column>
					<vxe-table-column field="bankName"
									  title="开户行名称"
									  show-overflow-tooltip
									  align="center"
									  min-width="140"></vxe-table-column>
					<vxe-table-column field="inAcctNo"
									  title="转入账号"
									  align="center"
									  show-overflow-tooltip
									  width="300"></vxe-table-column>
					<vxe-table-column field="inName"
									  title="转入户名"
									  align="center"
									  width="300"></vxe-table-column>
					<vxe-table-column field="inTranAmt"
									  title="转入本金金额"
									  show-overflow-tooltip
									  align="center"
									  width="240"></vxe-table-column>
					<vxe-table-column field="result"
									  title="是否成功"
									  align="center"
									  width="120">
						<template slot-scope="scope">
							<span v-if="scope.row.result == 0">失败</span>
							<span v-else-if="scope.row.result == 1">成功</span>
						</template></vxe-table-column>
				</vxe-table>
			</div>
		</div>
	</div>
</template>

<script>
import { selectBanks, selectDepositRefundPage } from 'api/modules/bank'
import { mapState } from 'vuex'
import { dateFormat } from 'utils/tools'
export default {
	name: 'Bond',
	components: {},
	data() {
		return {
			bankList: [],
			detailTable: [],
			detailData: {
				serialNo: '111'
			},
			filterData: [
				{
					score: '92'
				}
			],
			searchForm: {
			
			},
			loading: false,
			//筛选框
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			searchToggle: true,
			tableShow: true
		}
	},

	created() {
		selectBanks().then(res => {
			this.bankList = res.data
		})
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('searchForm')) {
				this.searchForm = JSON.parse(this.$getSessionItem('searchForm'))

				// 移除 避免污染
				this.$removeSessionItem('searchForm')
			}

			if (this.$getSessionItem('currentPage')) {
				this.currentPage = JSON.parse(
					this.$getSessionItem('currentPage')
				)

				// 移除 避免污染
				this.$removeSessionItem('currentPage')
			}

			if (this.$getSessionItem('pageSize')) {
				this.pageSize = JSON.parse(this.$getSessionItem('pageSize'))

				// 移除 避免污染
				this.$removeSessionItem('pageSize')
			}
		}
		this.getData()
	},
	methods: {
		//重置筛选框
		resetSerach() {
			this.currentPage = 1
			this.pageSize = 10
			this.searchForm = {}
			this.getData()
		},

		refresh() {
			this.currentPage = 1
			this.pageSize = 10
			this.searchForm = {}
			this.getData()
		},

		//查看明细
		getDetail(params) {
			this.detailData = params
			this.detailTable = params.details
			let arr = {
				id: params.id,
				current: 1,
				size: 10,
				applyState: '1'
			}

			// 存值
			this.$setSessionItem('searchForm', JSON.stringify(this.searchForm))
			this.$setSessionItem(
				'currentPage',
				JSON.stringify(this.currentPage)
			)
			this.$setSessionItem('pageSize', JSON.stringify(this.pageSize))

			this.$router.push({
				path: 'bond',
				query: {
					type: 'detail',
					id: params.id
				}
			})
		},
		//字符串插入
		insertStr(soure, start, newStr) {
			return soure.slice(0, start) + newStr + soure.slice(start)
		},
		//返回列表
		goBack() {
			this.$router.push({ path: '/bond' })
		},

		//获得列表数据
		getData() {
			if (
				this.searchForm.evaTime != '' &&
				this.searchForm.evaTime != null
			) {
				this.searchForm.startDate = dateFormat(
					'',
					this.searchForm.evaTime[0]
				)
				this.searchForm.endDate = dateFormat(
					'',
					this.searchForm.evaTime[1]
				)
			} else {
				this.searchForm.startDate = ''
				this.searchForm.endDate = ''
			}
			let params = Object.assign({}, this.searchForm)
			this.loading = true
			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize
			selectDepositRefundPage(params)
				.then(res => {
					this.loading = false
					this.filterData = res.data.records
					this.filterData.forEach(v => {
						var reg = /^(\d{4})(\d{2})(\d{2})$/
						v.transDate = v.transDate.replace(reg, '$1-$2-$3')
						v.transTime = this.insertStr(v.transTime, 4, ':')
						v.transTime = this.insertStr(v.transTime, 2, ':')
					})
					this.currentPage = parseInt(res.data.current)
					this.total = parseInt(res.data.total)
					this.pageSize = parseInt(res.data.size)

					// 设置回显
					this.setChecked()
				})
				.catch(err => {
					this.loading = false
				})
		},

		//筛选框重置
		handleClose() {
			this.dialogObj.visible = false
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getData()
		},

		// 是否展开搜索区域
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 搜索
		searchResult() {
			this.currentPage = 1
			this.pageSize = 10
			this.getData()
		}
	},

	computed: {
		...mapState('app', { isBack: state => state.isBack }),
		...mapState('dict', { ywly: state => state.ywly }),
		routeQuery() {
			return this.$route.query.type
		}
	},

	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
			setTimeout(() => {
				this.$refs.xTable.doLayout()
			}, 1000)
		}
	}
}
</script>

<style lang="less" scoped>
.operation-layout {
	padding: 0 8px;
	.search {
		border-bottom: 1px solid #2672cc;
		padding: 5px 0;
	}
	.mt4 {
		margin-top: 10px;
		text-align: right;
	}
	.cmain {
		height: 100%;
		overflow-y: auto;
		.common-top {
			// padding: 20px 0 0 0;
			text-align: right;
			.card-area {
				margin-top: 15px;
				line-height: 35px;
				margin-left: 30px;
				font-size: 14px;
				.text-overflow {
					text-align: left;
				}
			}
		}
		.table {
			margin-top: 0px;
			height: 510px;
			text-align: center;
			overflow: auto;
		}
	}
}
</style>
